<template>
  <div v-if="!(store.loading || contactKindStore.loading) && !store.error && store.data">
    <v-tabs
      v-model="tab"
      bg-color="primary"
      align-tabs="center"
      stacked
      show-arrows
      density="compact"
    >
      <v-tab value="content">
        Inhalt
      </v-tab>
      <v-tab value="files">
        Dateien
      </v-tab>
      <v-tab value="documents">
        Dokumente
      </v-tab>
      <v-tab value="bediener">
        Bediener
      </v-tab>
      <v-tab value="emails">
        E-Mail
      </v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item value="content">
        <v-list>
          <v-list-item v-if="store.data.KundeName"
                       :link="store.data.KundenNr > 0"
                       :to="store.data.KundenNr > 0 ? {name: 'customer_details', params: {
        contact_id: store.data.KundenNr,
      }} : undefined">
            <template #prepend>
              <v-icon>mdi-account</v-icon>
            </template>

            <v-list-item-subtitle>Kunde</v-list-item-subtitle>
            <v-list-item-title>
              {{ store.data.KundeName }}
            </v-list-item-title>

          </v-list-item>
          <v-list-item>
            <template #prepend>
              <v-icon color="primary">{{ store.data.typeIcon }}</v-icon>
            </template>

            <v-list-item-subtitle>{{
                contactKindStore.shortToFull(store.data.Art)
              }}
            </v-list-item-subtitle>
            <v-list-item-title>
              <strong>{{ store.data.Thema }}</strong>
            </v-list-item-title>

          </v-list-item>
          <v-list-item v-if="store.data.AnsprechpartnerFormatted"
                       :link="store.data.Ansprechpartner[0].AnsprechpartnerNr > 0"
                       :to="store.data.Ansprechpartner[0].AnsprechpartnerNr > 0 ? {name: 'customer_contact_details', params: {
          contact_id: store.data.Ansprechpartner[0].AnsprechpartnerNr,
      }} : undefined">
            <template #prepend>
              <v-icon>mdi-account</v-icon>
            </template>

            <v-list-item-subtitle>Ansprechpartner</v-list-item-subtitle>
            <v-list-item-title>
              {{ store.data.AnsprechpartnerFormatted }}
            </v-list-item-title>

          </v-list-item>
          <v-list-item v-if="store.data.Disponent">
            <template #prepend>
              <v-icon>mdi-account</v-icon>
            </template>

            <v-list-item-subtitle>Disponent</v-list-item-subtitle>
            <v-list-item-title>
              {{ dispatcherStore.shortToFull(store.data.Disponent) }}
            </v-list-item-title>

          </v-list-item>
          <v-list-item>
            <template #prepend>
              <v-icon>mdi-calendar</v-icon>
            </template>

            <v-list-item-subtitle>Datum</v-list-item-subtitle>
            <v-list-item-title>
              {{ store.data.AnlageDatumFormatted }}
            </v-list-item-title>

          </v-list-item>
          <v-list-item v-if="store.data.Erledigt">
            <template #prepend>
              <v-icon :color="store.data.color">{{ store.data.icon }}</v-icon>
            </template>

            <v-list-item-title>Erledigt</v-list-item-title>

          </v-list-item>
        </v-list>
        <hr/>
        <v-list>
          <v-list-item v-if="content">
            <div style="white-space: pre-line; word-wrap: break-word; word-break: break-all">{{ content }}</div>
            <v-btn variant="outlined"
                   @click="expanded = !expanded"
                   v-if="expandable"
                   class="mt-2"
                   block>
              <v-icon>{{expanded ? 'mdi-chevron-double-up' : 'mdi-chevron-double-down'}}</v-icon>
              {{ expanded ? "" : "Mehr anzeigen" }}</v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn
              class="mt-2"
              color="primary"
              variant="flat"
              block
              @click="showCommentModal = true"
            >
              <v-icon>mdi-plus</v-icon>
              Kommentieren
            </v-btn>
          </v-list-item>
        </v-list>
      </v-window-item>
      <v-window-item value="files">
        <v-list>
          <ApiDownloadItem
            v-for="datei in store.data.Dateien.Values"
            :key="datei.Dateiname"
            :token="datei.DownloadToken"
            :fileName="datei.Dateiname"
            :title="datei.Anmerkung || datei.Dateiname"
          />
          <v-list-item>
            <v-btn
              class="mt-2"
              color="primary"
              block
              variant="flat"
              :to="{
            name: 'contact_histories_document_create',
            params: {
              id: $route.params.id,
              contact_history_id: $route.params.contact_history_id,
            },
          }"
            >
              <v-icon>mdi-plus</v-icon>
              datei hinzufügen
            </v-btn>
          </v-list-item>
        </v-list>
      </v-window-item>
      <v-window-item value="documents">
        <v-list>
          <ApiDownloadItem
            v-for="document in store.data.Dokumente.Values"
            :key="document.Dateiname"
            :token="document.DownloadToken"
            :fileName="document.Dateiname"
            :title="document.Anmerkung || document.Dateiname"
          />
        </v-list>
      </v-window-item>
      <v-window-item value="bediener">
        <v-table dense>
          <thead>
          <tr>
            <th class="text-start">Bediener</th>
            <th class="text-start">Wiedervorlage</th>
            <th class="text-start">Gel.</th>
            <th class="text-start">Erl.</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="bed in bediener" :key="bed.Bediener">
            <td>{{ bed.Bediener }}</td>
            <td>{{ bed.Wiedervorlage }}</td>
            <td>
              <v-icon :color="bed.Gelesen ? 'success' : 'error'">
                {{
                  bed.Gelesen ? "mdi-email-open-outline" : "mdi-email-outline"
                }}
              </v-icon>
            </td>
            <td>
              <v-icon :color="bed.Erledigt ? 'success' : 'error'">
                {{ bed.Erledigt ? "mdi-check" : "mdi-close" }}
              </v-icon>
            </td>
          </tr>
          </tbody>
        </v-table>
      </v-window-item>
      <v-window-item value="emails">
        <v-list>
          <ApiEmailItem v-for="email in emails" :key="email.Id" :email="email" :contact-history="store.data"/>
        </v-list>
      </v-window-item>
    </v-window>
    <v-btn
      icon
      style="z-index: 1;"
      position="fixed"
      class="ma-3"
      location="bottom right"
      :to="{
        name: 'contact_history_edit',
        params: {
          id: $route.params.id,
          contact_history_id: $route.params.contact_history_id,
        },
      }"
      color="primary"
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
    <v-dialog v-model="showCommentModal" :persistent="loadingComment">
      <v-card>
        <v-card-title>Kommentar verfassen</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-textarea v-model="comment" label="Kommentar" variant="filled" :rules="[ruleRequired]"/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="postComment" color="primary" :loading="loadingComment">Kommentieren</v-btn>
          <v-btn @click="showCommentModal = false" variant="plain" :disabled="loadingComment">Abbrechen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <div v-else-if="store.error || contactKindStore.error || dispatcherStore.error">
    <Error v-if="store.error" :module="store.$id"/>
    <Error
      v-if="contactKindStore.error"
      :module="contactKindStore.error.message"
    />
    <Error
      v-if="dispatcherStore.error"
      :module="dispatcherStore.error.message"
    />
  </div>
  <Loading v-else/>
</template>

<script lang="ts" setup>
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import {useStorage} from '@/composables/storage';
import {useContactKindStore} from '@/store/contactKind';
import {useDispatcherStore} from '@/store/dispatcher';
import {computed, ref, watch} from 'vue';
import ApiDownloadItem from '@/components/ApiDownloadItem.vue';
import {postContactHistoryComment} from '@/api/module/contactHistory';
import router from '@/router';
import {postReadFlag, postCompleteFlag} from '@/api/module/followup';
import {useRoute} from 'vue-router';
import {formatDatum} from '@/model/ContactHistory';
import {useSettings} from '@/store/settings';
import pinia from '@/plugins/pinia';
import useDetailContactHistoryStore from '@/store/detailContactHistory';
import {VNodeRef} from 'vue';
import ApiEmailItem from '@/components/ApiEmailItem.vue';
import useDetailContactHistoryEmailStore from '@/store/detailContactHistoryEmail';
import {ContactHistoryEmail} from '@/model/ContactHistoryEmail';


const store = useDetailContactHistoryStore();
const emailStore = useDetailContactHistoryEmailStore();
const showCommentModal = ref(false);
const comment = ref('');
const form = ref<HTMLFormElement & VNodeRef | undefined>();
const loadingComment = ref(false);

const SPLIT_LENGTH = 800;
const bediener = computed(() => {
  const result = store.data?.Bediener.map((bed) => {
    return {
      Erledigt: bed.Erledigt.Status,
      Gelesen: bed.Gelesen.Status,
      Bediener: bed.Bediener,
      Wiedervorlage: formatDatum(
          bed.WiedervorlageDatum,
          bed.WiedervorlageUhrzeit ?? '',
          !!bed.WiedervorlageUhrzeit,
      ),
    };
  });
  if (!result) return result;
  const foundIndex = result.findIndex(
      (el) => el.Bediener === useSettings().userShort,
  );
  if (foundIndex > -1) {
    const [me] = result.splice(foundIndex, 1);
    result.unshift(me);
  }
  return result;
});

const tab = ref<'content'|'files'|'bediener'|'emails'|'documents'>('content');

const emails = computed(() => {
  return emailStore.data;
});
const postComplete = () =>
  postCompleteFlag({
    bediener: useSettings().userShort ?? '',
    kundennr: +route.params.id,
    kontaktnr: +route.params.contact_history_id,
    status: true,
  }).catch(console.error);
const contactKindStore = useContactKindStore();
const dispatcherStore = useDispatcherStore();
contactKindStore.fetch().catch(console.error);
dispatcherStore.fetch().catch(console.error);


const route = useRoute();

const expanded = ref(false);
const showEmailDialog = ref(false);
const selectedEmail = ref<ContactHistoryEmail|null>(null);

function openEmail(email: ContactHistoryEmail) {
  console.log('event');
  selectedEmail.value = email;
  showEmailDialog.value = true;
}

useStorage(
    store,
    (contactHistory) => (`Details: ${contactHistory ? contactHistory.KundeName : 'Kontakt'}`),
    (route) => {
      return {
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
        Nr: parseInt(Array.isArray(route.params.contact_history_id) ? route.params.contact_history_id[0] : route.params.contact_history_id),
      };
    },
);

useStorage(
    emailStore,
    undefined,
    (route) => {
      return {
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
        KontaktNr: parseInt(Array.isArray(route.params.contact_history_id) ? route.params.contact_history_id[0] : route.params.contact_history_id),
      };
    },
);

watch(() => store.loading, (loaded) => {
  if (!loaded && store.data?.Bediener.some((bed) => bed.Bediener === useSettings(pinia).userShort)) {
    postReadFlag({
      bediener: useSettings().userShort ?? '',
      kundennr: +route.params.id,
      kontaktnr: +route.params.contact_history_id,
      status: true,
    }).catch(console.error);

    const currentBediener = store.data?.Bediener.find((s) => s.Bediener == useSettings(pinia).userShort);
    if (currentBediener) {
      currentBediener.Gelesen.Status = true;
    }
  }
});

const expandable = computed(
    () => store.data?.Inhalt && store.data.Inhalt.length > SPLIT_LENGTH,
);

const content = computed(() => {
  if (!store.data) return undefined;
  if (!expandable.value || expanded.value) return store.data.Inhalt;

  const firstXChars = store.data.Inhalt?.substring(0, SPLIT_LENGTH);

  const linebreak = firstXChars?.lastIndexOf('\n');
  if (linebreak !== -1) {
    return `${firstXChars?.substring(0, linebreak)}`;
  }

  const word = firstXChars?.lastIndexOf(' ');
  if (word !== -1) {
    return `${firstXChars?.substring(0, word)} …`;
  }

  return `${firstXChars}…`;
});

const moreContentAvailable = computed(
    () => content.value?.length !== store.data?.Inhalt?.length,
);

async function postComment() {
  try {
    if (!form.value?.validate()) return;
    loadingComment.value = true;
    const id = parseInt(Array.isArray(router.currentRoute.value.params.id) ?
      router.currentRoute.value.params.id[0] : router.currentRoute.value.params.id);
    const contactHistoryId = parseInt(Array.isArray(router.currentRoute.value.params.contact_history_id) ?
      router.currentRoute.value.params.contact_history_id[0] : router.currentRoute.value.params.contact_history_id);
    await postContactHistoryComment(id, contactHistoryId, {
      Text: comment.value,
    });
    showCommentModal.value = false;
    comment.value = '';

    await store.fetch();
  } catch (err) {
    alert(err);
  } finally {
    loadingComment.value = false;
  }
}

function ruleRequired(val: any) {
  return !!val || val === 0 || 'erforderlich';
}

defineExpose({
  contactKindStore,
  bediener,
  postComplete,
  dispatcherStore,
  dchStore: store,
  Loading,
  Error,
  expanded,
  expandable,
  content,
  moreContentAvailable,
  ApiDownloadItem,
  showCommentModal,
  form,
  comment,
  postComment,
  ruleRequired,
  loadingComment,
});
</script>
